import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  OnInit,
  output,
  signal,
} from '@angular/core';
import { DecimalPipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonModule } from 'primeng/button';
import { SkeletonModule } from 'primeng/skeleton';
import { DocumentMonthSummaryDto, DocumentResponseDto } from '@taxora-shared-common/util';
import { DocumentRow } from './document-row';

@Component({
  selector: 'lib-document-month-group',
  templateUrl: './document-month-group.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DecimalPipe, TranslatePipe, ButtonModule, SkeletonModule, DocumentRow],
})
export class DocumentMonthGroup implements OnInit {
  readonly month = input.required<DocumentMonthSummaryDto>();
  readonly documents = input<DocumentResponseDto[]>([]);
  readonly isLoading = input<boolean>(false);
  readonly hasError = input<boolean>(false);
  readonly openByDefault = input<boolean>(false);
  readonly attentionCount = input<number>(0);

  readonly expand = output<DocumentMonthSummaryDto>();
  readonly documentClick = output<DocumentResponseDto>();
  readonly documentDownload = output<DocumentResponseDto>();
  readonly exportMonth = output<DocumentMonthSummaryDto>();
  readonly downloadMonth = output<DocumentMonthSummaryDto>();

  protected readonly isOpen = signal(false);

  ngOnInit(): void {
    if (this.openByDefault()) {
      this.isOpen.set(true);
      this.expand.emit(this.month());
    }
  }

  protected onToggle(): void {
    const wasOpen = this.isOpen();
    this.isOpen.set(!wasOpen);
    if (!wasOpen) {
      this.expand.emit(this.month());
    }
  }

  protected onDocumentClick(doc: DocumentResponseDto): void {
    this.documentClick.emit(doc);
  }

  protected onDocumentDownload(doc: DocumentResponseDto): void {
    this.documentDownload.emit(doc);
  }

  protected onExport(event: MouseEvent): void {
    event.stopPropagation();
    this.exportMonth.emit(this.month());
  }

  protected onDownload(event: MouseEvent): void {
    event.stopPropagation();
    this.downloadMonth.emit(this.month());
  }

  protected readonly totalAmount = computed(() => this.month().totalAmount);
  protected readonly currency = computed(() => this.month().currency ?? 'RON');
  protected readonly count = computed(() => this.month().filteredCount ?? this.month().count);
}
